import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { KpiDetailRow } from '@core/models/kpi.model';
import { ICONS } from '@core/services/icons/icons.service';

@Component({
  selector: 'app-kpi-detail-card',
  imports: [TranslatePipe],
  templateUrl: './kpi-detail-card.component.html',
  styles: `
    :host {
      display: contents;
    }
  `
})
export class KpiDetailCardComponent {
  readonly title = input.required<string>();
  readonly rows = input.required<readonly KpiDetailRow[]>();

  readonly dismiss = output<void>();

  protected readonly ICONS = ICONS;
}
